import React, { useMemo } from 'react';
import { AutocompleteArrayInput, useInput, useGetList } from 'react-admin';
import { makeStyles, InputLabel, LinearProgress } from '@material-ui/core';
import { useFormState } from 'react-final-form';

const useStyles = makeStyles({
  wrapper: {
    position: 'relative'
  },
  label: {
    marginTop: '-3px'
  },
  autocomplete: {
    marginTop: '-11px',
    '& > div > label': {
      display: 'none'
    },
    '& > div > div': {
      paddingLeft: '5px'
    }
  },
  suggestions: {
    top: '5px !important'
  },
  disabledInput: {
    pointerEvents: 'none',
    opacity: '0.5'
  }
});

const FundTagInput = ({ hasEditTagPermission }) => {
  const classes = useStyles();
  const formState = useFormState();

  const {
    data: tagsList = [],
    loading: tagLoading,
    total: totalTags
  } = useGetList('fundtags', null, null);

  const tagIds = Object.entries(formState.values.fundTags || {})
    .sort((a, b) => a[1].localeCompare(b[1]))
    .map(tag => parseInt(tag[0]));

  const customParse = value => {
    if (typeof value === 'object' && !Array.isArray(value)) {
      return value;
    }
    const formattedValue = {};
    Object.entries(tagsList).forEach(([_key, val]) => {
      if (value.includes(val.id)) {
        formattedValue[val.id] = val.name;
      }
    });
    return formattedValue;
  };

  const { input, isRequired, meta } = useInput({
    id: 'fundTagInput',
    resource: 'fundtags',
    source: 'fundTags',
    parse: customParse
  });
  input.value = tagIds;

  const additionalOptions = useMemo(() => {
    if (!hasEditTagPermission) {
      return {
        InputProps: {
          className: classes.disabledInput
        }
      };
    }
  }, [hasEditTagPermission, classes]);

  if (tagLoading) return <LinearProgress />;
  if (totalTags === 0) return null;

  return (
    <div className={classes.wrapper}>
      <InputLabel shrink className={classes.label}>
        Tags
      </InputLabel>
      <AutocompleteArrayInput
        id="fundTagInput"
        options={additionalOptions}
        disabled={!hasEditTagPermission}
        label=""
        source="fundTags"
        choices={Object.values(tagsList).sort((a, b) =>
          a.name.localeCompare(b.name)
        )}
        input={input}
        isRequired={isRequired}
        meta={meta}
        variant="standard"
        classes={{
          container: classes.autocomplete,
          suggestionsContainer: classes.suggestions
        }}
      />
    </div>
  );
};

export default FundTagInput;
